import { mergeClasses } from '@fluentui/react-components';
import DeleteLineItem from '../DeleteLineItem/DeleteLineItem';
import { ILineCardHeaderProps } from './LineCardHeader.types';
import { useLineCardHeaderStyles } from './LineCardHeader.styles';
import { useEffect, useMemo, useState } from 'react';
import MoveLine from '../MoveLine/MoveLine';
import { useLineEdit } from '../../../../../contexts/LineEditContext/LineEditContext.hooks';
import { useCart } from '../../../../../contexts/CartContext/CartContext.hooks';

const LineCardHeader = (props: ILineCardHeaderProps) => {
    const { item, readonly } = props;

    const styles = useLineCardHeaderStyles();

    const { GetMonthlyTotal, GetDueTodayTotal, TotalLines } = useLineEdit();

    const { cart } = useCart();

    const [monthlyPrice, setMonthlyPrice] = useState('$0.00');

    const [dueTodayPrice, setDueTodayPrice] = useState('$0.00');

    useEffect(() => {
        const monthly = GetMonthlyTotal(item.lineNumber);
        setMonthlyPrice(`$${monthly.amount.toFixed(2)}`);

        const today = GetDueTodayTotal(item.lineNumber);
        setDueTodayPrice(`$${today.amount.toFixed(2)}`);
    }, [cart.monthlySummary, cart.dueTodaySummary]);

    const PromoDisplay = useMemo(() => {
        return (
            item.promoSummary?.hasPromo && (
                <div className={styles.promoWrapper}>
                    <div className={mergeClasses(styles.itemInfoLabel, styles.promoInfoLabel)}>
                        Promo
                    </div>

                    <div className={mergeClasses(styles.itemInfo, styles.promoInfoLabel)}>
                        -${item.promoSummary.discount.toFixed(2)}
                    </div>
                </div>
            )
        );
    }, [item.promoSummary]);

    return (
        <div className={styles.root}>
            <div className={styles.lineHeaderWrapper}>
                <div className={styles.lineLabel}>
                    <h2 className={styles.lineHeader}>Line {item.lineNumber}</h2>

                    {TotalLines() > 1 && (
                        <div className={styles.orderButtons}>
                            <MoveLine lineNumber={props.item.lineNumber} />
                        </div>
                    )}
                </div>

                <div className={styles.amountDueWrapper}>
                    <div className={styles.itemInfoWrapper}>
                        <div className={styles.itemInfoLabel}>Due Monthly</div>

                        <div className={styles.itemInfo}>{monthlyPrice}</div>
                    </div>

                    <div className={styles.itemInfoWrapper}>
                        <div className={styles.itemInfoLabel}>Due Today</div>

                        <div className={styles.itemInfo}>{dueTodayPrice}</div>
                    </div>

                    <div className={styles.desktopPromoDisplay}>{PromoDisplay}</div>

                    {!readonly && (
                        <div className={styles.largeScreenDelete}>
                            <DeleteLineItem lineNumber={props.item.lineNumber} />
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.mobilePromoDisplay}>{PromoDisplay}</div>
        </div>
    );
};

export default LineCardHeader;
